import {Component, inject} from '@angular/core';
import {ShortcutContext} from './shortcut.context';
import {Dialog} from 'primeng/dialog';
import {ShortcutService} from './shortcut.service';
import {ShortcutHelpState} from './shortcut-help.context';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';

@Component({
	selector: 'app-shortcut-help',
	standalone: true,
	imports: [
		Dialog,
		Button,
		Tooltip
	],
	template: `
		<p-button class="fixed right-0 bottom-0 m-3 ghost-link"
				  size="small"
				  pTooltip="Guida scorciatoie"
				  plain
				  severity="secondary"
				  (onClick)="visible.set(true)">{{ modifier() }} + \\</p-button>

		<p-dialog header="Scorciatoie"
				  [(visible)]="visible"
				  position="bottomright"
				  [draggable]="false">
			<div class="flex gap-4">
				@for (entry of shortcutsBySection(); track entry[0]) {
					<div>
						<h5 class="font-bold mb-2">{{ entry[0] }}</h5>

						@for (s of entry[1]; track s.id) {
							<div class="flex align-items-center gap-3 mb-2">
								<div class="keys">
									@for (k of s.display; track k; let i = $index) {
										<kbd>
											@if (k.kind === 'modifier') {
												{{ modifier() }}
											} @else if (k.kind === 'arrow') {
												{{ k.dir === 'left' ? '←' : k.dir === 'right' ? '→' : k.dir === 'up' ? '↑' : '↓' }}
											} @else if (k.kind === 'icon') {
												<i class="{{ k.name }}"></i>
											} @else {
												{{ k.value }}
											}
										</kbd>
										@if (i < s.keys.length - 1) {+}
									}
								</div>
								<span>{{ s.description }}</span>
							</div>
						}
					</div>
				}
			</div>
		</p-dialog>
	`,
	styles: `
		.ghost-link {
			opacity: .4;
			transition: opacity .3s;
		}
		:hover.ghost-link {
			opacity: 1;
		}
		.keys {
			display: flex;
			gap: .2rem;
		}
	`
})
export class ShortcutHelpComponent {
	readonly ctx = inject(ShortcutContext)
	readonly service = inject(ShortcutService)
	private readonly state = inject(ShortcutHelpState)

	readonly shortcutsBySection = this.ctx.helpShortcutsBySection
	readonly modifier = this.service.modifierKey
	visible = this.state.visible
}
